import React, { useEffect, useState } from 'react';
import {
  View,
  ScrollView,
  Image,
  Linking,
  Pressable,
} from 'react-native';
import { widthPercentageToDP as wp } from 'react-native-responsive-screen';
import { Link, useNavigation } from '@react-navigation/native';

import CustomText from '../components/CustomText.js';
import Header from '../components/Header.js';
import Footer from '../components/Footer.js';
import Util from '../util/util.js';
import styles from '../style/screens/reportSubmittedStyles';
import { useResponsiveStyles } from '../hooks';
import { useTranslation } from '../i18n';

const ReportSubmitted = (props) => {
  const { t } = useTranslation('reports');

  // Defining local state values
  const { organization, admin, noLogin, location, report } = props.route.params;

  // Use responsive styles hook for platform detection
  const { isWeb, containerStyle } = useResponsiveStyles();

  const [viewportHeight, setViewportHeight] = useState(isWeb ? window.innerHeight : 0);

  if (report.hasOwnProperty('user')) {
    delete report['user'];
  }

  useEffect(() => {
    if (!isWeb) {
      return;
    }

    const handleResize = () => {
      setViewportHeight(window.innerHeight);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isWeb]);

  useEffect(() => {
    if (noLogin) {
      Util.executeQRSignIn(organization, noLogin);
    }
  }, []);

  const navigation = useNavigation();

  return (
    <View
      style={[
        containerStyle,
        { maxHeight: viewportHeight },
      ]}
    >
      {/* Global header  */}
      <Header organization={organization} admin={admin} noLogin={noLogin} location={location} />

      <ScrollView
        style={{ flex: 1, paddingHorizontal: wp(6), maxHeight: '100vh' }}
        contentContainerStyle={{ flexGrow: 1, justifyContent: 'space-around' }}
      >
        <View style={{}}>
          <CustomText
            style={{ textAlign: 'center' }}
            font="medium"
            size={48}
            color={'rgba(0,0,0,0.35)'}
          >
            {t('submitted.thankYou')}
          </CustomText>
        </View>

        <View style={styles.container}>
          <View style={styles.subContainer}>
            <CustomText style={{ textAlign: 'center' }} font="medium" size={24}>
              {t('submitted.linkPrompt')}
            </CustomText>
            <CustomText style={{ textAlign: 'center' }} font="medium" size={24}>
              <Link
                onPress={() => {
                  navigation.navigate('ReportDetails', {
                    uuid: report.uuid,
                    noLogin: true,
                    organization: organization,
                    location: location,
                  });
                }}
              >
                {t('submitted.viewReport')}
              </Link>
            </CustomText>
          </View>

          <View style={styles.subContainer}>
            <CustomText style={{ textAlign: 'center' }} font="medium" size={24}>
              {t('submitted.emailNote')}
            </CustomText>
          </View>

          <View style={styles.subContainer}>
            <CustomText style={{ textAlign: 'center' }} font="medium" size={24}>
              {t('submitted.analyticsPrompt')}
              <Link
                onPress={() => {
                  navigation.navigate('AnalyticsScreen', props.route.params);
                }}
              >
                {' '}
                {t('submitted.analyticsLink')}
              </Link>
            </CustomText>
          </View>
        </View>

        <View style={styles.bottomContainer}>
          <View style={styles.bottomSubContainer}>
            <CustomText style={{ textAlign: 'center' }} font="medium" size={24}>
              {t('submitted.appPrompt')}
            </CustomText>
          </View>

          <View style={styles.imageSubContainer}>
            <Pressable
              onPress={() =>
                Linking.openURL(
                  'https://play.google.com/store/apps/details?id=com.monetatech.moneta',
                )
              }
            >
              <Image
                source={require('../assets/images/google_play.png')}
                style={[styles.image, { marginBottom: 5 }]}
                resizeMode="contain"
              />
            </Pressable>
            <Pressable
              onPress={() =>
                Linking.openURL('https://apps.apple.com/us/app/monetatech/id6477671241')
              }
            >
              <Image
                source={require('../assets/images/apple.png')}
                style={styles.image}
                resizeMode="contain"
              />
            </Pressable>
          </View>
        </View>
      </ScrollView>

      <Footer admin={admin} organization={organization} noLogin={noLogin} location={location} />
    </View>
  );
};

export default ReportSubmitted;
